import { t } from 'i18next';
import { observer } from 'mobx-react';

import { useMeasurement } from '@/hooks/useMeasurement';
import { useGetCompressorSliderPoints } from '@/comp/MapBuilder/nodes/compressor/CompressorNodeWidget.utils';
import { CompressorActivityStateEnum } from '@/constants/enums';
import { useStores } from '@/hooks/use-stores';
import { Entity } from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget.types';

import Slider from '../Slider/Slider';

const BoosterSliders = observer(({ entity }: { entity: Entity }) => {
  const { tvalue, tunit } = useMeasurement();
  const { stationStore } = useStores();
  const { connectivity, pressureBar, activity, minimumPressureBar, maximumPressureBar } = entity;

  return (
    <div className="main-slider">
      <Slider
        showTierLock
        title={t('Pressure')}
        value={tvalue(Number(pressureBar?.toFixed(2)), 'bar')}
        unit={t(tunit('Bar'))}
        min={tvalue(Number(minimumPressureBar?.toFixed(2)), 'bar')}
        max={tvalue(Number(maximumPressureBar?.toFixed(2)), 'bar')}
        points={useGetCompressorSliderPoints(entity, stationStore.hasNewActionsFeature)}
        connectivity={connectivity}
        highlightSlider={activity?.toLowerCase() === CompressorActivityStateEnum.Load}
        addSideGaps
        hasTarget
      />
    </div>
  );
});

export default BoosterSliders;
